import { SUMMARY_BOOKLET_SUCCESS, SUMMARY_BOOKLET_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case SUMMARY_BOOKLET_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case SUMMARY_BOOKLET_FAILURE:
			return { ...state, isLoading: false, errorData: action.payload, error: true };
		default:
			return { ...state };
	}
};
